import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { MenuItem } from '../../../types';
import { getMenuIcon } from '../../../services/navigation';

const NavItem: React.FC<{
  menuData: MenuItem;
  isMainMenuOpen: boolean;
  isActive: boolean;
  onToogle: (e: any) => void;
  setMainMenuOpen: (isMainMenuOpen?: any) => void;
}> = ({ menuData, setMainMenuOpen, isMainMenuOpen, isActive, onToogle }) => {
  const location = useLocation();
  const selectedPage = `#${location.pathname}`;

  const handleSubmenuToggle = (event: React.MouseEvent) => {
    !isActive && event.preventDefault();
    onToogle(event);
  };

  const handleMainMenuToggle = (event: React.MouseEvent) => {
    !isMainMenuOpen && event.preventDefault();
    !isMainMenuOpen && event.stopPropagation();
    setMainMenuOpen((prevOpen: boolean) => !prevOpen);
    event.target === event.currentTarget && onToogle(event);
  };

  const handleSubMenuSelection = () => {
    setMainMenuOpen(false);
  };

  const hasSubmenuMatch = menuData.subMenus.filter((sm: any) => sm.url === selectedPage).length > 0;
  return (
    <Nav.Item>
      <Nav.Link
        href={menuData.url}
        eventKey={menuData.id}
        onClick={
          isMainMenuOpen && menuData.subMenus.length > 0
            ? handleSubmenuToggle
            : handleMainMenuToggle
        }
        active={
          selectedPage === menuData.url || hasSubmenuMatch
            ? true
            : false
        }
      >
        <FontAwesomeIcon icon={getMenuIcon(menuData.icon)} />
        <span className={'link-name'}>{menuData.title}</span>
        {menuData.subMenus.length > 0 &&
          (!isActive ? (
            <FontAwesomeIcon
              icon={light('chevron-right')}
              className={'ms-auto me-0'}
            />
          ) : (
            <FontAwesomeIcon
              icon={light('chevron-down')}
              className={'ms-auto me-0'}
            />
          ))}
      </Nav.Link>
      {isMainMenuOpen && isActive && menuData.subMenus.length > 0 && (
        <section className={'sub-nav-wrapper'}>
          {menuData.subMenus.map((submenu: any, index: number) => (
            <Nav.Item key={index}>
              <Nav.Link
                href={`${menuData.key}${submenu.url}`}
                eventKey={submenu.id}
                onClick={handleSubMenuSelection}
                active={
                  Boolean(submenu.url) && selectedPage === `${submenu.url}`
                    ? true
                    : false
                }
              >
                <span className={'link-name'}>{submenu.title}</span>
                {submenu.notificationCount && (
                  <span className={'notification-count'}>
                    {submenu.notificationCount}
                  </span>
                )}
              </Nav.Link>
            </Nav.Item>
          ))}
        </section>
      )}
    </Nav.Item>
  );
};

export default NavItem;
